import React from 'react';

const EvoMLIntegrations = () => {
  const integrations = [
    {
      category: 'Data Sources',
      items: [
        { name: 'AWS S3', icon: '☁️' },
        { name: 'Google Cloud Storage', icon: '🔷' },
        { name: 'Azure Blob Storage', icon: '🔵' },
        { name: 'PostgreSQL', icon: '🐘' },
        { name: 'MongoDB', icon: '🍃' }
      ]
    },
    {
      category: 'ML Frameworks',
      items: [
        { name: 'TensorFlow', icon: '🧠' },
        { name: 'PyTorch', icon: '🔥' },
        { name: 'Scikit-learn', icon: '📊' },
        { name: 'XGBoost', icon: '🚀' },
        { name: 'LightGBM', icon: '⚡' }
      ]
    },
    {
      category: 'Deployment Platforms',
      items: [
        { name: 'Kubernetes', icon: '☸️' },
        { name: 'Docker', icon: '🐳' },
        { name: 'AWS SageMaker', icon: '🤖' },
        { name: 'Azure ML', icon: '🔷' },
        { name: 'Google AI Platform', icon: '🎯' }
      ]
    }
  ];

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
      <h1 style={{ fontSize: '2.5em', marginBottom: '20px', color: '#333' }}>
        EvoML Integrations
      </h1>
      <p style={{ fontSize: '1.2em', color: '#666', marginBottom: '40px' }}>
        Seamlessly connect EvoML with your existing tech stack
      </p>
      
      {integrations.map((section, index) => (
        <div key={index} style={{ marginBottom: '50px' }}>
          <h2 style={{ fontSize: '1.8em', marginBottom: '25px', color: '#444' }}>
            {section.category}
          </h2>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', 
            gap: '20px' 
          }}>
            {section.items.map((item, itemIndex) => (
              <div key={itemIndex} style={{
                background: '#f8f9fa',
                padding: '20px',
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                transition: 'all 0.2s',
                cursor: 'pointer',
                ':hover': {
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }
              }}>
                <span style={{ fontSize: '2em' }}>{item.icon}</span>
                <span style={{ fontSize: '1.1em', fontWeight: '500', color: '#555' }}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default EvoMLIntegrations; 